const chains = {
  mono: {
    a: {
      b: 3,
      c: 10,
      l: 18,
      f: 1,
      g: 2,
      i: 6,
      d: 4,
      y: 4,
      m: 7,
      n: 16,
      p: 2,
      r: 17,
      s: 7,
      u: 2,
      t: 9,
      v: 2,
      k: 2
    },
    b: { l: 3, o: 5, a: 2, e: 13, r: 1, u: 2, j: 1 },
    l: {
      e: 14,
      m: 1,
      o: 8,
      r: 1,
      w: 1,
      i: 8,
      d: 5,
      l: 8,
      a: 5,
      t: 4,
      y: 3,
      f: 1,
      p: 1,
      k: 2,
      u: 1
    },
    o: {
      u: 13,
      v: 6,
      s: 6,
      n: 20,
      t: 6,
      m: 8,
      r: 15,
      d: 5,
      o: 9,
      k: 2,
      l: 7,
      p: 4,
      c: 4,
      w: 8,
      f: 3,
      i: 2,
      b: 1,
      g: 2
    },
    u: {
      t: 4,
      n: 8,
      a: 1,
      l: 6,
      s: 5,
      i: 3,
      r: 10,
      e: 4,
      g: 3,
      p: 2,
      m: 2,
      c: 2,
      b: 2,
      d: 3
    },
    v: { e: 18, i: 3, a: 1, o: 1 },
    c: {
      c: 2,
      o: 13,
      r: 2,
      t: 7,
      k: 3,
      a: 6,
      e: 17,
      h: 7,
      i: 5,
      l: 3,
      u: 4
    },
    n: {
      t: 16,
      s: 4,
      g: 9,
      o: 5,
      y: 3,
      d: 13,
      e: 6,
      n: 1,
      u: 2,
      c: 5,
      a: 4,
      m: 1,
      i: 3,
      l: 1,
      k: 1
    },
    r: {
      o: 13,
      e: 26,
      r: 3,
      i: 7,
      y: 4,
      t: 8,
      s: 2,
      k: 2,
      l: 3,
      c: 1,
      m: 1,
      a: 4,
      n: 4,
      g: 1,
      d: 4,
      v: 1,
      u: 1
    },
    s: {
      s: 6,
      t: 18,
      w: 1,
      k: 1,
      e: 15,
      i: 6,
      y: 2,
      u: 6,
      o: 6,
      c: 2,
      h: 1,
      m: 1,
      p: 1
    },
    t: {
      i: 8,
      u: 7,
      e: 18,
      h: 17,
      t: 4,
      w: 1,
      a: 9,
      y: 1,
      r: 7,
      o: 8,
      l: 1
    },
    i: {
      v: 4,
      n: 19,
      r: 3,
      f: 4,
      e: 5,
      l: 4,
      t: 7,
      d: 5,
      c: 7,
      o: 3,
      g: 6,
      m: 3,
      k: 1,
      s: 1,
      a: 2
    },
    f: { t: 2, u: 2, o: 7, f: 4, e: 5, i: 4, a: 5, r: 1 },
    e: {
      r: 34,
      a: 25,
      c: 10,
      f: 1,
      g: 2,
      h: 1,
      l: 7,
      v: 7,
      s: 9,
      t: 7,
      e: 10,
      n: 20,
      y: 3,
      i: 3,
      x: 2,
      w: 3,
      p: 1,
      d: 1,
      o: 1,
      m: 6,
      k: 1
    },
    g: { a: 3, i: 3, e: 5, h: 8, u: 1, o: 2, r: 4 },
    m: { o: 9, e: 12, m: 2, p: 5, i: 2, a: 7, u: 1, b: 2 },
    d: { y: 3, e: 13, a: 4, i: 3, o: 3, u: 2, d: 1 },
    w: { a: 6, e: 6, n: 3, h: 1, o: 4, r: 1 },
    y: { s: 2, o: 2, e: 1 },
    h: { e: 11, i: 4, a: 3, o: 8, t: 5, r: 2 },
    p: { p: 1, e: 6, a: 3, l: 7, o: 4, r: 5, u: 2 },
    x: { a: 1, p: 1 },
    k: { e: 4, i: 1, n: 1 },
    q: { u: 3 },
    j: { e: 1 }
  },
  bi: {
    ab: { l: 1, o: 2 },
    bl: { e: 2, i: 1 },
    bo: { u: 1, v: 1, d: 1, o: 1, t: 1 },
    ou: { t: 2, n: 4, r: 2, g: 3, p: 1, s: 1 },
    ov: { e: 5, i: 1 },
    ac: { c: 1, r: 1, t: 3, k: 1, e: 2, h: 2 },
    cc: { o: 1, e: 1 },
    co: { u: 2, m: 4, l: 2, n: 4, r: 1 },
    un: { t: 2, d: 4, i: 1, g: 1 },
    cr: { o: 1, e: 1 },
    ro: {
      s: 1,
      u: 3,
      l: 1,
      w: 1,
      b: 1,
      c: 1,
      d: 1,
      g: 1,
      v: 1,
      o: 1,
      n: 1
    },
    os: { s: 1, t: 2, e: 3 },
    ct: { i: 2, u: 1, o: 1 },
    ti: { v: 1, f: 1, n: 1, o: 3, m: 1, l: 1 },
    iv: { e: 4 },
    tu: { a: 1, r: 4, d: 2 },
    ua: { l: 1 },
    af: { t: 1 },
    ft: { e: 2 },
    te: { r: 8, n: 1, m: 1, a: 2, l: 1 },
    ag: { a: 2 },
    ga: { i: 2, m: 1 },
    ai: { n: 4, r: 1, t: 1 },
    in: { s: 1, d: 3, g: 3, e: 2, u: 1, a: 1, t: 2, c: 1, k: 1 },
    ns: { t: 1, w: 1, i: 1, e: 1 },
    al: { m: 1, o: 1, r: 1, w: 1, l: 2, f: 1, t: 1, k: 2, u: 1 },
    lm: { o: 1 },
    mo: { s: 2, n: 4, r: 1, t: 1, v: 1 },
    lo: { n: 2, s: 1, p: 1, w: 1, c: 1, o: 1, v: 1 },
    on: { g: 4, d: 2, s: 1, t: 3, e: 1, c: 1, l: 1 },
    lr: { e: 1 },
    re: { a: 8, n: 2, c: 3, s: 2, m: 2, e: 3 },
    ea: { d: 3, r: 6, u: 1, t: 2, s: 4, l: 2, v: 1, n: 1, c: 2, m: 1 },
    ad: { y: 1, e: 1 },
    lw: { a: 1 },
    wa: { y: 1, r: 1, i: 1, l: 1, n: 1, t: 1 },
    ay: { s: 1 },
    am: { o: 1, p: 1, i: 1, e: 2 },
    an: { o: 1, s: 1, y: 3, n: 1, g: 1, d: 3, t: 2 },
    no: { t: 2, u: 1, w: 1, r: 1 },
    ot: { h: 4 },
    th: { e: 6, i: 1, o: 2, r: 2 },
    he: { r: 6, c: 1, a: 3, l: 1 },
    sw: { e: 1 },
    we: { r: 2, e: 2, l: 1, s: 1 },
    ap: { p: 1, e: 1 },
    pp: { e: 1 },
    pe: { a: 1, r: 2, n: 1, o: 1, c: 1 },
    ar: { e: 2, o: 1, r: 2, k: 1, l: 1, t: 4, g: 1, n: 1, d: 1 },
    rr: { i: 1, y: 1, e: 1 },
    ri: { v: 1, n: 2, e: 2, g: 1, t: 1 },
    as: { k: 1, e: 1, s: 1, y: 1, u: 1, o: 2 },
    ba: { c: 1, s: 1 },
    be: { a: 1, c: 2, f: 1, g: 1, h: 1, l: 1, s: 1, t: 2, y: 1, r: 2 },
    au: { t: 1, s: 1 },
    ut: { i: 1, h: 1 },
    if: { u: 1, f: 2, e: 1 },
    fu: { l: 2 },
    ec: { a: 1, o: 3, k: 1, i: 2, t: 2, e: 1 },
    ca: { u: 1, l: 2, n: 1, r: 2 },
    us: { e: 3, i: 2 },
    om: { e: 3, m: 1, p: 2, a: 1 },
    ef: { o: 1 },
    fo: { r: 3, l: 1, o: 2, u: 1 },
    or: { e: 1, c: 1, m: 1, t: 3, n: 1, d: 3, y: 1, k: 1, l: 1 },
    eg: { i: 1, e: 1 },
    gi: { n: 1, r: 1, v: 1 },
    eh: { i: 1 },
    hi: { n: 2, l: 1, g: 1 },
    el: { i: 1, o: 1, p: 1, l: 2 },
    li: { e: 1, f: 1, g: 1, k: 1, n: 1, s: 1, t: 1, c: 1 },
    ie: { v: 1, n: 3, w: 1 },
    ev: { e: 7 },
    es: { t: 4, s: 4, u: 1 },
    et: { t: 2, w: 1, e: 1, h: 1 },
    tt: { e: 3, l: 1 },
    tw: { e: 1 },
    ee: { n: 1, l: 1, p: 1, t: 2, d: 1, m: 1, k: 1 },
    ey: { o: 1, e: 1 },
    yo: { n: 1, u: 1 },
    od: { y: 1, u: 1, a: 1 },
    oo: { k: 2, s: 1, r: 1, d: 2, t: 1, m: 1, l: 1 },
    br: { i: 1 },
    bu: { i: 1, s: 1 },
    ui: { l: 1, c: 1, t: 1 },
    il: { d: 2, y: 1 },
    si: { n: 2, d: 2, c: 1, m: 1 },
    ne: { s: 1, r: 1, y: 1, e: 1, w: 1 },
    nn: { o: 1 },
    ce: { n: 2, r: 1, s: 2, i: 1 },
    en: { t: 7, c: 3, o: 1, d: 1, e: 1, s: 1 },
    nt: { e: 3, u: 1, i: 2, r: 1, h: 1 },
    ur: { y: 1, s: 1, e: 4, r: 1, i: 1, n: 1 },
    er: { t: 1, e: 2, y: 1, i: 1, a: 1, n: 1, v: 1, s: 1 },
    rt: { a: 2, h: 2 },
    ta: { i: 1, n: 3, r: 1, t: 1, k: 1, l: 1 },
    ch: { a: 1, e: 1, i: 1, o: 2 },
    ha: { n: 2, l: 1 },
    ng: { e: 1 },
    ho: { o: 2, m: 1, u: 2, r: 1, s: 1, l: 1 },
    ci: { t: 1, d: 1, e: 1, a: 2 },
    it: { y: 1, h: 1, t: 1, e: 2 },
    cl: { a: 1, e: 1, o: 1 },
    la: { s: 1, r: 1, c: 1, n: 1, y: 1 },
    le: { a: 3, g: 1, t: 2, s: 1, m: 1 },
    ol: { d: 2, l: 2, e: 1 },
    ll: { e: 1, o: 1 },
    mm: { o: 1, e: 1 },
    mp: { a: 1, l: 3, o: 1 },
    pa: { n: 1, p: 1, r: 1 },
    pl: { e: 4, a: 3 },
    id: { e: 5 },
    de: { r: 4, c: 1, v: 1, a: 1, n: 2 },
    nu: { e: 1, m: 1 },
    tr: { o: 2, e: 2, a: 2, u: 1 },
    rs: { e: 1, t: 1 },
    at: { e: 3, a: 1, h: 1, t: 1, i: 1, u: 1 },
    cu: { l: 2, r: 1, t: 1 },
    ul: { t: 3, l: 2 },
    lt: { u: 1, h: 1 },
    da: { r: 1, t: 1, y: 2 },
    ve: { l: 2, n: 3, r: 4 },
    di: { f: 2, r: 1 },
    ff: { e: 2, i: 2 },
    fe: { r: 2, e: 1, w: 1 },
    nc: { e: 5 },
    fi: { c: 2, g: 1, n: 1 },
    ic: { u: 1, e: 3, k: 1 },
    ir: { e: 1, l: 1 },
    io: { n: 3 },
    do: { c: 1, o: 1, w: 1 },
    oc: { t: 1, a: 1, e: 1, i: 1 },
    to: { r: 2, d: 1, g: 1, l: 1, p: 1, w: 2 },
    ow: { n: 3, e: 1, a: 1 },
    du: { r: 1, c: 1 },
    rl: { y: 1, d: 1 },
    ei: { g: 1, t: 1, v: 1 },
    ig: { h: 5, u: 1 },
    gh: { t: 5 },
    ug: { h: 3 },
    ex: { a: 1, p: 1 },
    xa: { m: 1 },
    xp: { e: 1 },
    fa: { c: 2, m: 1, r: 1, t: 1 },
    mi: { l: 1, n: 1 },
    gu: { r: 1 },
    na: { l: 1, m: 1, t: 2 },
    rc: { e: 1 },
    fr: { i: 1 },
    ge: { n: 1, t: 1 },
    ra: { l: 1, m: 1, d: 1, v: 1 },
    go: { o: 1, v: 1 },
    rn: { m: 1, i: 1 },
    nm: { e: 1 },
    me: { n: 1, a: 2, e: 1, m: 1, r: 1 },
    gr: { e: 1, o: 2, a: 1 },
    im: { p: 2, e: 1 },
    po: { r: 1, i: 1, w: 1, n: 1 },
    ke: { e: 1 },
    ki: { n: 1 },
    kn: { o: 1 },
    rg: { e: 1 },
    av: { e: 2 },
    ik: { e: 1 },
    is: { t: 1 },
    tl: { e: 1 },
    ma: { k: 1, n: 3, t: 1, i: 1, l: 1 },
    ak: { e: 2 },
    su: { r: 1, l: 1, b: 1, c: 1, d: 1, m: 1 },
    ni: { n: 1, g: 1, t: 1 },
    mu: { s: 1 },
    um: { b: 1, m: 1 },
    mb: { e: 2 },
    of: { f: 2, t: 1 },
    nl: { y: 1 },
    op: { e: 1, l: 1 },
    rd: { e: 1 },
    eo: { p: 1 },
    oi: { n: 1, c: 1 },
    pr: { o: 5 },
    ob: { l: 1 },
    uc: { t: 1, c: 1 },
    og: { r: 1, e: 1 },
    vi: { d: 1, c: 1, e: 1 },
    pu: { b: 1, l: 1 },
    ub: { l: 1, j: 1 },
    qu: { e: 1, i: 2 },
    ue: { s: 1 },
    st: { i: 1, a: 4, o: 1, r: 2, u: 2, e: 1 },
    so: { n: 2, c: 1, m: 1, u: 2 },
    em: { a: 1, e: 1, b: 1 },
    sc: { h: 1, i: 1 },
    se: { a: 1, c: 1, e: 1, n: 1, r: 1, v: 1 },
    rv: { i: 1 },
    sh: { o: 1 },
    sm: { a: 1 },
    ia: { l: 2 },
    sp: { e: 1 },
    ud: { e: 1, y: 1, d: 1 },
    bj: { e: 1 },
    je: { c: 1 },
    dd: { e: 1 },
    sy: { s: 1 },
    ys: { t: 1 },
    hr: { e: 1, o: 1 },
    ru: { e: 1 },
    nd: { e: 2 },
    up: { o: 1 },
    va: { l: 1 },
    lu: { e: 1 },
    vo: { i: 1 },
    wh: { o: 1 },
    wo: { m: 1, r: 3 },
    wr: { i: 1 }
  }
}

function weightedRandom(choices) {
  const letters = Object.keys(choices);
  const weights = Object.values(choices);

  const total = weights.reduce((a, b) => a + b, 0);
  let r = Math.random() * total;

  for (let i = 0; i < letters.length; i++) {
    r -= weights[i];
    if (r <= 0) return letters[i];
  }

  return null;
}

const nextLetter = (prevLetters) => {
  const { mono, bi } = chains;
  prevLetters = prevLetters.toLowerCase();

  // Try bigram if possible
  if (prevLetters.length >= 2) {
    const bigram = prevLetters.slice(-2);  // last two letters
    if (bi[bigram]) {
      return weightedRandom(bi[bigram]);
    }
  }

  // Fallback to monogram
  const last = prevLetters.slice(-1);
  if (mono[last]) {
    return weightedRandom(mono[last]);
  }

  return null; // No known transitions
}

export default nextLetter;